interface WithResolvers {
  resolve: (value: unknown) => void
  reject: (reason?: any) => void
  promise: Promise<unknown>
}

export function withResolvers(): WithResolvers {
  let resolve: WithResolvers['resolve'] = () => ({})
  let reject: WithResolvers['reject'] = () => ({})

  const promise = new Promise((resolve_, reject_) => {
    resolve = resolve_
    reject = reject_
  })

  return {
    resolve,
    reject,
    promise,
  }
}
